export default function ({ store, route, redirect, error }) {
    // if (!store.state.authUser) {
    //     error({
    //         message: 'You are not connected',
    //         statusCode: 403
    //     })
    //     return redirect('/login')
    // }
    return true
}



// WEBPACK FOOTER //
// ./middleware/auth.js